import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-0"}],["path",{"d":"M12 8.5v7","key":"svg-1"}],["path",{"d":"M9 10l6 4","key":"svg-2"}],["path",{"d":"M9 14l6 -4","key":"svg-3"}]]

const IconSquareAsterisk = createReactComponent('outline', 'square-asterisk', 'SquareAsterisk', __iconNode);

export default IconSquareAsterisk;